module.exports = __webpack_public_path__ + "img/nl.0b607386.png";